// @import dependencies
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import React, { CSSProperties } from 'react'
// @end dependencies

// @import components
import { Modal } from 'react-bootstrap';
// @end components

// @import types
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ModalReprogramingForm.scss'
import { AiOutlineCloseCircle } from 'react-icons/ai';
import ReprogramingForm from '../ReprogramingForm/ReprogramingForm';
// @end styles

interface IModalReprogramingFormProps {
  open: boolean
  title?: string
  className?: string
  classNameModal?: string
  style?: CSSProperties
  id?: string
  onClose?: (data: any)=>any
}

const ModalReprogramingForm: React.FC<IModalReprogramingFormProps> = (props) => {

  /**
   * @INFO Click en cerrar
   */
   const handleClickClose = () => {
    if(props.onClose){
      props.onClose({status: 'closed'})
    }
  }

  const handleFormSaved = (data: any) => {
    if (props.onClose) {
      props.onClose({
        status: 'saved',
        data,
      })
    }
  }

  return(
    <Modal
      className={`modal-reprograming-form-container ${props.classNameModal ? props.classNameModal : ''}`}
      show={props.open}
      onHide={handleClickClose}
      centered
    >
      <Modal.Body
        style={{
          padding: '0px'
        }}
      >
        <div
          className={`modal_reprograming_form-layout ${props.className ? props.className : ''}`}
          style={props.style}
          id={props.id}
        >
          <AiOutlineCloseCircle
            className='close-icon'
            onClick={handleClickClose}
          />
          {props.title ?
            <TextComponent
              type='subtitle'
            >
              {props.title}
            </TextComponent>
          :null}
          <ReprogramingForm
            onHandleSubmit={handleFormSaved}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalReprogramingForm;
